<template>
  <div id="park-list" class="park-list">
    <div class="search-box">
      <el-form :model="search" ref="search">
        <el-row>
          <el-col :span="8">
            <el-form-item prop="name">
              <el-autocomplete
                prefix-icon="el-icon-search"
                v-model="search.name"
                :fetch-suggestions="querySearch"
                @select="handleSelect"
                style="width: 100%"
                placeholder="请输入行业、行政区划、地块名称、宗地编号"
                clearable
              ></el-autocomplete>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <div class="need-area">
              面积：

              <el-input
                type="number"
                v-model="search.areaMin"
                class="need-area-input"
              ></el-input>
              -
              <el-input
                type="number"
                v-model="search.areaMax"
                class="need-area-input"
              ></el-input>
              <span>亩</span>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="search-btn">
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="searchList"
                >查询
              </el-button>
              <el-button icon="el-icon-refresh-right" @click="refreshList">
                重置刷新
              </el-button>
            </div>
          </el-col>
          <el-col :span="2">
            <div class="develop" @click="develop">
              <el-button type="primary" :icon="iconDown" @click="searchList"
                >高级搜索
              </el-button>
            </div>
          </el-col>
        </el-row>
        <el-collapse-transition>
          <div v-show="showList2">
            <div class="title-select">
              <!--行政区划-->
              <el-row class="bottom-line-dashed">
                <el-col :span="2"
                  ><span class="tool-title">行政区划:</span></el-col
                >
                <el-col :span="21">
                  <div
                    class="content"
                    :class="[isXzqhShrink ? 'shrink' : '']"
                    v-for="item in xzqhList"
                    :key="item.id"
                  >
                    <el-input
                      v-model="countyName"
                      @change="changeCounty"
                      @clear="
                        countyList = [];
                        showList = false;
                        xzqh.zs = null;
                        xzqh.qx = null;
                        isXzqhShrink = true;
                      "
                      style="width: 120px"
                      clearable
                    ></el-input>
                    <span
                      :class="[xzqh.zs ? '' : 'span-active']"
                      @click="
                        (xzqh.zs = null),
                          (xzqh.qx = null),
                          (countyName = ''),
                          (search.county = null),
                          searchList()
                      "
                      >全部</span
                    >

                    <span
                      v-for="(zs, index) in item.children"
                      :key="index"
                      :class="[xzqh.zs == zs ? 'span-active' : '']"
                      @click="
                        (xzqh.zs = xzqh.zs == zs ? null : zs), (xzqh.qx = null)
                      "
                    >
                      <!-- <i class="color-4" v-if="index < 4">hot</i> -->
                      {{ zs.label }}
                      <!-- <i class="iconfont icon-remen color-2" v-if="index < 4"></i> -->
                    </span>
                    <div
                      class="more"
                      v-if="isXzqhShrink"
                      @click="isXzqhShrink = !isXzqhShrink"
                    >
                      ...更多
                    </div>
                    <div
                      class="shrink-btn"
                      v-if="!isXzqhShrink"
                      @click="isXzqhShrink = !isXzqhShrink"
                    >
                      收起
                    </div>
                  </div>
                  <!-- isXzqhShrink ? 'shrink-child' : '', -->
                  <div
                    :class="['content content2']"
                    v-if="xzqh.zs && !isXzqhShrink"
                  >
                    <span
                      v-for="(qx, qxIndex) in xzqh.zs.children"
                      :key="qxIndex"
                      :class="xzqh.zs && xzqh.qx == qx ? 'span-active' : ''"
                      @click="xzqh.qx = xzqh.qx == qx ? null : qx"
                      >{{ qx.label }}</span
                    >
                  </div>
                </el-col>
                <div class="input-box scrollbar-definition" v-show="showList">
                  <div
                    v-for="(item, index) in countyList"
                    :key="index"
                    @click="selectCounty(item)"
                  >
                    {{ item.name }}
                  </div>
                  <div
                    v-if="showList && !countyList.length"
                    @click="showList = false"
                  >
                    无匹配数据
                  </div>
                </div>
              </el-row>
              <!--开发区-->
              <el-row class="bottom-line-dashed">
                <el-col :span="2"
                  ><span class="tool-title">开发区:</span></el-col
                >
                <el-col :span="21">
                  <div class="content" :class="[isShrink ? 'shrink' : '']">
                    <el-input
                      v-model="parkName"
                      @change="changePark"
                      @clear="countyParkList = []"
                      style="width: 120px"
                      clearable
                    ></el-input>
                    <span
                      :class="[search.parkCode == '' ? 'span-active' : '']"
                      @click="
                        search.parkCode = '';
                        search.parkLevel = '';
                        searchList();
                        getPark();
                      "
                      >全部</span
                    >
                    <span
                      :class="[
                        search.parkLevel == item.value ? 'span-active' : '',
                      ]"
                      v-for="(item, index) in parkLevel"
                      :key="index"
                      @click="searchPark(item, index)"
                    >
                      {{ item.name }}
                    </span>
                    <div
                      class="more"
                      v-if="isShrink"
                      @click="isShrink = !isShrink"
                    >
                      ...更多
                    </div>
                    <div
                      class="shrink-btn"
                      v-if="!isShrink"
                      @click="isShrink = !isShrink"
                    >
                      收起
                    </div>
                  </div>
                  <div :class="['content content2']" v-if="!isShrink">
                    <span
                      v-for="(j, i) in parkList"
                      :key="i"
                      :class="
                        search.parkCode == j.parkCode ? 'span-active' : ''
                      "
                      @click="
                        search.parkCode =
                          search.parkCode == j.parkCode ? null : j.parkCode;
                        searchList();
                      "
                      >{{ j.parkName }}</span
                    >
                  </div>
                </el-col>
                <div
                  class="input-box scrollbar-definition"
                  v-show="showParkList"
                >
                  <div
                    v-for="(item, index) in countyParkList"
                    :key="index"
                    @click="selectCountyPark(item)"
                  >
                    {{ item.parkName }}
                  </div>
                  <div
                    v-if="showParkList && !countyParkList.length"
                    @click="showParkList = false"
                  >
                    无匹配数据
                  </div>
                </div>
              </el-row>
              <!--土地用途-->
              <el-row class="bottom-line-dashed">
                <el-col :span="2"
                  ><span class="tool-title">土地用途:</span></el-col
                >
                <el-col :span="20">
                  <div class="content">
                    <span
                      :class="tdyt.lv1 ? '' : 'span-active'"
                      @click="(tdyt.lv1 = null), (tdyt.lv2 = null)"
                      >全部</span
                    >
                    <span
                      v-for="(item, index) in tdytList"
                      :key="index"
                      :class="tdyt.lv1 == item ? 'span-active' : ''"
                      @click="
                        (tdyt.lv1 = tdyt.lv1 == item ? null : item),
                          (tdyt.lv2 = null)
                      "
                      >{{ item.name }}</span
                    >
                  </div>
                  <div class="content content2" v-if="tdyt.lv1">
                    <span
                      v-for="(item, index) in tdyt.lv1.child"
                      :key="index"
                      :class="tdyt.lv1 && tdyt.lv2 == item ? 'span-active' : ''"
                      @click="tdyt.lv2 = item"
                      >{{ item.name }}</span
                    >
                  </div>
                </el-col>
              </el-row>

              <!--标签-->
              <el-row>
                <el-col :span="2"><span class="tool-title">行业:</span></el-col>
                <el-col :span="20">
                  <div class="content" :class="[isindustry ? 'shrink' : '']">
                    <span
                      :class="[search.industryType == '' ? 'span-active' : '']"
                      @click="
                        search.industryType = '';
                        cyIndex = -1;
                        searchList();
                      "
                      >全部</span
                    >
                    <span
                      v-for="(item, index) in labelList"
                      :key="index"
                      :class="[
                        search.industryType == item.code ? 'span-active' : '',
                      ]"
                      @click="
                        search.industryType =
                          search.industryType == item.code ? '' : item.code;
                        cyIndex = cyIndex == index ? -1 : index;
                        searchList();
                      "
                    >
                      {{ item.name }}
                    </span>
                    <div
                      class="more"
                      v-if="isindustry"
                      @click="isindustry = !isindustry"
                    >
                      ...更多
                    </div>
                    <div
                      class="shrink-btn"
                      v-if="!isindustry"
                      @click="isindustry = !isindustry"
                    >
                      收起
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-collapse-transition>
      </el-form>
    </div>
    <div class="park-list-table-no-top">
      <div class="comparison-switch">
        <div class="screen-box">
          <div
            :class="[
              'screen-box-div',
              search.sort == 1 ? 'screen-box-active' : '',
            ]"
            @click="changeSort(1)"
          >
            热度
            <i
              :class="[
                'el-icon-sort-down',
                search.sort == 1 && !search.sortFlag ? 'screen-box-icon' : '',
              ]"
            >
            </i>
            <i
              :class="[
                'el-icon-sort-up',
                search.sort == 1 && search.sortFlag ? 'screen-box-icon' : '',
              ]"
            ></i>
          </div>

          <div
            :class="[
              'screen-box-div',
              search.sort == 3 ? 'screen-box-active' : '',
            ]"
            @click="changeSort(3)"
          >
            面积
            <i
              :class="[
                'el-icon-sort-down',
                search.sort == 3 && !search.sortFlag ? 'screen-box-icon' : '',
              ]"
            >
            </i>
            <i
              :class="[
                'el-icon-sort-up',
                search.sort == 3 && search.sortFlag ? 'screen-box-icon' : '',
              ]"
            ></i>
          </div>
        </div>
        <!-- search-button-bgc1 -->
        <el-button-group style="margin-left: 10px">
          <el-button
            size="small "
            :type="supplyPeriod1 ? 'primary' : ''"
            @click="searchList1()"
            >立等可供</el-button
          >
          <el-button
            size="small "
            :type="supplyPeriod3 ? 'primary' : ''"
            @click="searchList3()"
            >计划可供</el-button
          >
          <!-- <el-button
            size="small "
            :type="supplyPeriod2 ? 'primary' : ''"
            @click="searchList2()"
            >规划可用</el-button
          > -->
        </el-button-group>
        <!-- <div
          class="search-button"
          :class="supplyPeriod1 ? 'select-bgc' : ''"
          @click="searchList1()"
        >
          <span>立等可供</span>
        </div>
        <div
          class="search-button"
          :class="supplyPeriod2 ? 'select-bgc' : ''"
          @click="searchList2()"
        >
          <span>近期可供</span>
        </div>
        <div
          class="search-button"
          :class="supplyPeriod3 ? 'select-bgc' : ''"
          @click="searchList3()"
        >
          <span>计划可供</span>
        </div> -->
        <div class="transfer-announce-status">
          <span>出让公告：</span>
          <el-radio-group v-model="search.transferAnnounceStatus" size="small">
            <el-radio-button label="  ">全部</el-radio-button>
            <el-radio-button :label="true">已发布</el-radio-button>
            <el-radio-button :label="false">未发布</el-radio-button>
          </el-radio-group>
        </div>
        <div
          class="screen-box"
          @click="
            search.isReserve == 1
              ? (search.isReserve = '')
              : (search.isReserve = 1);
            searchList();
          "
          style="margin-top: 3px"
        >
          <div
            :class="['screen-box-div']"
            :style="{
              background: search.isReserve == 1 ? '#2090FF' : '',
              color: search.isReserve == 1 ? '#fff' : '',
            }"
          >
            储备土地
          </div>
        </div>

        <el-switch
          @change="searchList"
          v-model="search.transaction"
          active-color="#13ce66"
          active-value="2"
          inactive-value="1"
          active-text="已成交"
          style="margin-left: 20px"
        >
        </el-switch>

        <!-- <el-switch @change="searchList" v-model="search.transferAnnounceStatus" active-color="#13ce66"
          :active-value="true" :inactive-value="false" active-text="已发布出让公告" style="margin-left: 20px">
        </el-switch> -->
        <el-switch
          v-model="isComparison"
          active-text="对比"
          style="margin-left: 20px"
        ></el-switch>
        <el-switch
          v-model="search.isPanorama"
          active-text="720全景"
          style="margin-left: 20px"
          active-value="1"
          inactive-value="0"
          @change="searchList"
        ></el-switch>
      </div>

      <div>
        <span>未找到地块？</span>
        <span class="font-red" @click="releaseNeed">提交需求！</span>
      </div>

      <!-- isDetailedList -->
    </div>

    <div
      class="table-box"
      v-if="tableList.length || loading"
      v-loading="loading"
    >
      <div
        style="cursor: pointer"
        v-for="(item, index) in tableList"
        class="card-base"
        :key="index"
        v-show="tableList.length"
        :style="index + 1 == 5 || index + 1 == 10 ? 'margin-right:0' : ''"
      >
        <div>
          <div
            class="card-base-box"
            @click="
              $router.push({ path: '/land/detail', query: { id: item.id } })
            "
          >
            <img
              :src="
                item.imgUrl
                  ? item.imgUrl
                  : require('../../assets/images/home/land.png')
              "
              height="162px"
              width="245px"
              alt=""
            />
          </div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="item.industryTypeName"
            placement="bottom"
          >
            <div class="left-top" v-if="item.industryTypeName">
              {{ item.industryTypeName }}
            </div>
          </el-tooltip>
          <!-- <div class="left-top" v-if="item.industryTypeName">
            {{ item.industryTypeName }}
          </div> -->

          <div class="right-top" v-if="item.parkName">
            <!-- <el-popover placement="bottom"  width="150" trigger="hover"
              :content="item.parkName">
               <span slot="reference">{{item.parkName}}</span>
             
            </el-popover> -->
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.parkName"
              placement="bottom-end"
            >
              <span>{{ item.parkName }}</span>
            </el-tooltip>
            <!-- {{item.parkName}} -->

            <!-- <span>{{item.parkName}}</span> -->
          </div>
          <!-- <div class="right-bottom" v-if="item.transferAnnounceStatus">
            出让公告
          </div> -->
          <div style="height: 90px">
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.name || item.code"
              placement="bottom"
            >
              <span class="card-title">{{ item.name || item.code }}</span>
            </el-tooltip>

            <br />
            <div class="text-center">
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.typeName"
                placement="bottom"
              >
                <el-tag
                  class="card-info"
                  v-show="item.typeName == null ? false : true"
                  >{{ item.typeName }}</el-tag
                >
              </el-tooltip>

              <el-tag class="card-info" type="warning">{{
                item.countyName
              }}</el-tag>
              <!--                <el-tag class="card-info" type="info"-->
              <!--                  >{{ item.transferDate }}年</el-tag-->
              <!--                >-->
            </div>
            <div style="display: flex; align-items: center">
              <div
                :class="
                  item.supplyPeriod == 1
                    ? 'available'
                    : item.supplyPeriod == 3
                    ? 'availableNear'
                    : item.supplyPeriod == 4
                    ? 'availability'
                    : ''
                "
                class="park-detail-top-title3-li1 park-detail-top-title3-span1"
              >
                <!--                <img style="width: 15px; margin-right: 5px" :src="item.supplyPeriod == 1? img01: item.supplyPeriod == 2? img02: item.supplyPeriod == 3? img03: ''" alt=""/>-->
                {{
                  item.supplyPeriod == 1
                    ? "立等可供"
                    : item.supplyPeriod == 3
                    ? "计划可供"
                    : item.supplyPeriod == 4
                    ? "规划可用"
                    : ""
                }}
              </div>
              <div
                class="dk-announcement"
                v-if="item.transferAnnounceStatus && item.transaction != '2'"
              >
                <!-- <img src="@/assets/images/gk.png" alt="" /> -->
                <span>已发布出让公告</span>
              </div>
              <div class="dk-announcement1" v-if="item.isReserve == 1">
                <span>储备土地</span>
              </div>
            </div>
          </div>
          <div class="text-bottom">
            <!--价格-->
            <div class="price">
              <span class="iconfont icon-mianji"></span>
              <span style="padding-left: 5px">{{ item.area }}亩</span>
              <!-- <span>面议</span>-->
            </div>
            <div
              :id="index == 0 ? 'park-list-table-checkbox-1' : ''"
              class="park-list-table-checkbox"
              @click.stop=""
              v-if="isComparison"
            >
              <el-checkbox
                v-model="item.checked"
                size="medium"
                :true-label="1"
                :false-label="0"
                @change="changeChecked($event, item)"
              ></el-checkbox>
            </div>
            <!--展示浏览量-->
            <el-tooltip placement="right" :open-delay="1000">
              <div slot="content">
                浏览量：{{ item.statistical | filter_statistical }}
              </div>
              <div class="pageView" v-if="!isComparison">
                <browse :statistical="item.statistical"></browse>
              </div>
            </el-tooltip>
          </div>
        </div>
        <div
          v-if="search.transaction == 2"
          :class="['card-mask', search.transaction == 2 ? 'yjy-color' : '']"
          @click="
            $router.push({ path: '/land/detail', query: { id: item.id } })
          "
        >
          {{ search.transaction == 2 ? "已成交" : "" }}
        </div>
      </div>
    </div>

    <div class="park-list-table-no" v-show="!tableList.length && !loading">
      <div class="park-list-table-no-c">
        <div class="park-list-table-no-c-img">
          <img src="../../assets/images/common/1.png" alt="" />
        </div>
        <div class="park-list-table-no-c-span">
          抱歉，没有找到符合条件的结果
        </div>
        <!-- <div class="park-list-table-no-c-btn" @click="releaseNeed">
          提交需求
        </div> -->
      </div>
    </div>
    <div class="page-box" v-if="tableList.length">
      <el-pagination
        :current-page="search.current"
        :page-sizes="[10, 20, 40, 80]"
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="search.size"
        layout=" prev, pager, next,total, jumper "
        :total="total"
      ></el-pagination>
    </div>

    <!-- 对比框 -->
    <!-- <div class="contrast-box" v-if="isShow">
      <contrast :list="contrastList" @callBack="callBack"></contrast>
    </div> -->

    <!-- 对比清单 -->
    <div class="contrast-list" v-show="isDetailedList">
      <detailed-list
        :contrast-list="contrastList"
        @callBack="callBack"
        @delContrast="delContrast"
      ></detailed-list>
    </div>
    <tools>
      <template v-slot:contrast>
        <div
          id="badge-box-1"
          v-if="isComparison"
          class="badge-box2"
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding-top: 20px;
          "
        >
          <el-badge
            :value="contrastList.length"
            class="item"
            style="font-size: 1.55rem; cursor: pointer"
          >
            <img
              class="badge-img"
              src="@/assets/images/common/list1.png"
              @click="detailedListsShow"
            />
          </el-badge>
          <div style="font-size: 12px">对比地块</div>
        </div>
      </template>
    </tools>
  </div>
</template>
<script>
import {
  dictionaries,
  getXzqhList,
  getTypeList,
  getCodeChildren,
} from "@/api/common";
import {
  landList,
  getIndustryList,
  getAdministrative,
  getCountyParkList,
  searchDefault,
} from "@/api/setting/investment";
import contrast from "./components/contrast";
import card from "./components/card";
import detailedList from "./components/detailedList";
import Driver from "driver.js";
import Browse from "@/components/currency/browse";
import Tools from "@/views/home/components/tools";
import img03 from "@/assets/images/land/ldkg1.png";
import img04 from "@/assets/images/land/jqkg1.png";
import img05 from "@/assets/images/land/jhkg1.png";

export default {
  name: "landList",
  components: { card, contrast, detailedList, Browse, Tools },
  data() {
    return {
      img01: img03,
      img02: img04,
      img03: img05,
      countyName: "",
      search: {
        unSupplyPeriod: 4, //默认不查询规划可用数据
        name: "",
        isPanorama: 0, //720全景
        //  xzqh: [],
        county: "",
        areaMin: null,
        areaMax: null,
        type: "",
        size: 10,
        current: 1,
        parkCode: "",
        parkLevel: "",
        industryType: "",
        // label: "",
        // labelName: "",
        transaction: 1, //交易状态
        sort: 1, //按什么排序
        sortFlag: true, //是否降序
        supplyPeriod: "",
        typeArr: [],
        transferAnnounceStatus: "  ",
        isReserve: "",
      },
      area: [30, 60],
      total: 0,
      tableList: [],
      xzqhList: [],
      tdytList: [],
      loading: true,
      contrastList: [], //对比数组id
      isShow: false,
      isDetailedList: false, //清单
      isComparison: false,
      isShrink: true, //开发区是否展开
      isXzqhShrink: true, //行政区划是否展开
      isindustry: true,
      xzqh: {
        //行政区划对象
        zs: null, //洲市
        qx: null, //区县
      },
      tdyt: {
        lv1: null, // 第一级
        lv2: null, //第二级
      }, //土地用途对象
      parkList: [],
      cityList: [],
      labelList: [],
      countyList: [], //搜索行政区划列表
      showList: false, //搜索行政区划列表是否显示
      parkName: "", //搜索园区名称
      countyParkList: [], //搜索园区列表
      showParkList: false, //搜索园区列表是否显示

      supplyPeriod1: false,
      supplyPeriod2: false,
      supplyPeriod3: false,
      restaurants: [],
      iconDown: "el-icon-arrow-down",
      showList2: true,
      cyIndex: -1,
      parkLevel: [
        { value: "DZXQ", name: "滇中新区" },
        { value: "1", name: "国家级" },
        { value: "2", name: "省级" },
        // { value: "3", name: "其他" },
      ],
    };
  },
  filters: {
    filter_statistical(value) {
      let value1 = 0;
      if (value > 10000) {
        value1 = (value / 10000).toFixed(1) + "万";
      } else {
        value1 = value;
      }
      return value1.toString();
    },
  },
  watch: {
    "search.name": function (val) {
      if (val) {
        let list = JSON.parse(sessionStorage.getItem("landSearchList"))
          ? JSON.parse(sessionStorage.getItem("landSearchList"))
          : [];
        if (list.length) {
          let index = list.findIndex((item) => item.value == val);
          if (index == -1) {
            list.push({ value: val });
            sessionStorage.setItem("landSearchList", JSON.stringify(list));
          }
        } else {
          list.push({ value: val });
          sessionStorage.setItem("landSearchList", JSON.stringify(list));
        }
        this.restaurants = JSON.parse(sessionStorage.getItem("landSearchList"))
          ? JSON.parse(sessionStorage.getItem("landSearchList"))
          : [];
      }
    },
    "search.transferAnnounceStatus": {
      handler(val) {
        //  console.log(val);
        this.search.transferAnnounceStatus = val;
        this.searchList();
      },
      deep: true,
    },
    xzqh: {
      deep: true,
      handler(newVal) {
        if (newVal.zs && newVal.qx == null) {
          this.search.county = newVal.zs.value;
        }
        if (newVal.zs && newVal.qx) {
          this.search.county = newVal.qx.value;
        }
        if (newVal.zs == null && newVal.qx == null) {
          this.search.county = null;
        }
        this.searchList();
      },
    },
    //土地用途
    tdyt: {
      deep: true,
      handler(newVal) {
        if (newVal.lv1 && newVal.lv2 == null) {
          this.search.type = newVal.lv1.code;
        }
        if (newVal.lv1 && newVal.lv2) {
          this.search.type = newVal.lv2.code;
        }
        if (newVal.lv1 == null && newVal.lv2 == null) {
          this.search.type = null;
        }
        this.searchList();
      },
    },
    "search.typeArr": {
      deep: true,
      handler(newVal) {
        if (newVal.length) {
          let len = newVal.length - 1;
          this.search.type = newVal[len];
        } else {
          this.search.type = "";
        }
      },
    },

    countyName: function (val) {
      if (!val) {
        this.xzqh.zs = null;
        this.xzqh.qx = null;
        this.isXzqhShrink = true;
      }
    },
    isComparison: function (newVal, oldVal) {
      if (!newVal) {
        this.isDetailedList = false;
      }
    },
  },
  created() {
    window.addEventListener("keydown", this.handkeyCode, true); //开启监听键盘按下事件
  },
  mounted() {
    this.restaurants = JSON.parse(sessionStorage.getItem("landSearchList"))
      ? JSON.parse(sessionStorage.getItem("landSearchList"))
      : [];
    if (!this.restaurants.length) {
      this.getSearchDefault();
    }
    this.getXzqh();
    this.getList();
    //this.getField("TDYT", "tdytList");
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "1405px";
    this.gettdlx();
    this.getLabelList();
    this.getPark();
    // this.getCodeChildren("53", "cityList");
  },
  methods: {
    //搜索园区
    searchPark(item, index) {
      this.search.parkLevel =
        this.search.parkLevel == item.value ? null : item.value;
      if (item.name == "滇中新区") {
        this.search.parkCode = item.value;
        this.parkList = [];
        this.searchList();
      } else {
        this.search.parkCode = null;
        this.getPark();
      }
      if (item.value == 1 || item.value == 2 || item.value == 3) {
        this.isShrink = false;
      } else {
        this.isShrink = true;
      }

      // if(item.value!="DZXQ"){
      //   this.isShrink=!this.isShrink
      // }
    },
    // 收起展开
    develop() {
      if (this.iconDown === "el-icon-arrow-up") {
        this.iconDown = "el-icon-arrow-down";
      } else {
        this.iconDown = "el-icon-arrow-up";
      }
      this.showList2 = !this.showList2;
    },
    //搜索默认值
    getSearchDefault() {
      searchDefault({ type: 1 }).then((res) => {
        if (res.data.success) {
          this.restaurants = res.data.data;
        }
      });
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    handleSelect(item) {},
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    changePark(val) {
      //如果有值查询
      if (val) {
        this.showParkList = true;
        getCountyParkList({
          parkName: this.parkName,
          divisionCode: this.search.county ? this.search.county : "",
        }).then((res) => {
          if (res.data.success) {
            this.countyParkList = res.data.data;
          }
        });
      } else {
        this.search.parkCode = "";
        this.searchList();
      }
    },
    selectCountyPark(item) {
      this.search.parkCode = item.parkCode;
      this.parkName = item.parkName;
      this.showParkList = false;
      this.searchList();
    },
    changeCounty(val) {
      if (val) {
        this.showList = true;
        getAdministrative({ name: val }).then((res) => {
          if (res.data.success) {
            this.countyList = res.data.data;
          }
        });
      } else {
        this.search.county = "";
        this.searchList();
      }
    },
    selectCounty(data) {
      this.search.county = data.code;
      this.countyName = data.name;
      this.showList = false;
      let childrenS = this.xzqhList[0].children;
      if (data.code.length == 4) {
        let index = childrenS.findIndex((item) => data.code == item.value);
        if (index != -1) {
          this.xzqh.zs = childrenS[index];
          this.isXzqhShrink = false;
        }
      }
      if (data.code.length == 6) {
        let str1 = data.code.slice(0, 4);
        let index = childrenS.findIndex((item) => str1 == item.value);
        if (index != -1) {
          this.xzqh.zs = childrenS[index];
          this.isXzqhShrink = false;
          let index1 = childrenS[index].children.findIndex(
            (item) => data.code == item.value
          );
          if (index1 != -1) {
            this.xzqh.qx = childrenS[index].children[index1];
          }
        }
      }
      this.searchList();
    },
    //切换排序
    changeSort(val) {
      // if (this.search.sort == val) {
      //   this.search.sort = null;
      // } else {
      //   this.search.sort = val;
      // }
      this.search.sort = val;
      this.search.sortFlag = !this.search.sortFlag;
      this.searchList();
    },
    changeSortFlag() {
      this.search.sortFlag = !this.search.sortFlag;
      this.searchList();
    },
    //选择交易状态
    changeTransaction(val) {
      if (this.search.transaction == val) {
        this.search.transaction = null;
      } else {
        this.search.transaction = val;
      }
    },

    getLabelList() {
      getIndustryList().then((res) => {
        if (res.data.success) {
          this.labelList = res.data.data;
        }
      });
    },
    //行政区划获取下级
    getCodeChildren(code, arrName) {
      getCodeChildren({ value: code }).then((res) => {
        if (res.data.success) {
          this["arrName"] = res.data.data;
        }
      });
    },
    getPark() {
      getCountyParkList({
        parkLevel: this.search.parkLevel ? this.search.parkLevel : "",
      }).then((res) => {
        if (res.data.success) {
          this.parkList = res.data.data;
        }
      });
    },
    gettdlx() {
      getTypeList({ search: true }).then((res) => {
        if (res.data.success) {
          this.tdytList = res.data.data;
        }
      });
    },
    // 加载功能引导
    guide() {
      let driver = new Driver();
      driver.defineSteps([
        {
          element: "#park-list-table-checkbox-1",
          popover: {
            title: "第一步：勾选地块，勾选两个以上",
            description: "需要勾选两个以上的地块才可以进行对比。",
            position: "left",
            doneBtnText: "确定",
            closeBtnText: "关闭",
            nextBtnText: "下一步",
            prevBtnText: "上一步",
          },
        },
        {
          element: "#badge-box-1",
          popover: {
            title: "第二步：点击对比",
            description:
              "勾选完地块后，点击这里，会弹出已选择的地块的列表，再点击对比按钮就可以开始对比啦。",
            position: "bottom",
            doneBtnText: "确定",
            closeBtnText: "关闭",
            nextBtnText: "下一步",
            prevBtnText: "上一步",
          },
        },
      ]);
      driver.start();
    },
    callBack() {
      this.isDetailedList = false;
      this.isComparison = false;
    },
    //删除对应对比
    delContrast(index, id) {
      this.contrastList.splice(index, 1);
      let index1 = this.tableList.findIndex((item) => item.id == id);
      this.tableList[index1].checked = false;
    },
    getField(field, identification) {
      let data = { field: field };
      dictionaries(field).then((res) => {
        this[identification] = res.data.data;
      });
    },
    //获取行政区划
    getXzqh() {
      getXzqhList().then((res) => {
        if (res.data.success) {
          this.xzqhList = res.data.data;
        }
      });
    },
    detailedListsShow() {
      if (!this.contrastList.length) {
        this.$message.warning("请选择需要进行对比的地块！");
        // this.$confirm("您选择的园区为空，是否需要功能引导？").then(() => {
        //   this.guide();
        // });
      } else if (this.contrastList.length < 2) {
        this.$message.warning("请选择至少两个地块进行对比！");
      } else {
        this.isDetailedList = true;
      }
    },
    searchList1() {
      this.supplyPeriod1 = !this.supplyPeriod1;
      this.supplyPeriod2 = false;
      this.supplyPeriod3 = false;
      if (this.supplyPeriod1) {
        this.search.supplyPeriod = "1";
        this.searchList();
      } else {
        this.search.supplyPeriod = "";
        this.searchList();
      }
    },
    searchList2() {
      this.supplyPeriod2 = !this.supplyPeriod2;
      this.supplyPeriod1 = false;
      this.supplyPeriod3 = false;
      if (this.supplyPeriod2) {
        this.search.supplyPeriod = "4";
        this.searchList();
      } else {
        this.search.supplyPeriod = "";
        this.searchList();
      }
    },
    searchList3() {
      this.supplyPeriod3 = !this.supplyPeriod3;
      this.supplyPeriod1 = false;
      this.supplyPeriod2 = false;
      if (this.supplyPeriod3) {
        this.search.supplyPeriod = "3";
        this.searchList();
      } else {
        this.search.supplyPeriod = "";
        this.searchList();
      }
    },
    searchList() {
      // if (this.search.xzqh.length) {
      //   this.search.county = this.search.xzqh[this.search.xzqh.length - 1];
      // }
      if (!this.search.transferAnnounceStatus) {
        this.search.transferAnnounceStatus = false;
        this.search.current = 1;
        this.getList();
        // this.search.transferAnnounceStatus = false;
        return;
      }
      this.search.current = 1;
      this.getList();
    },

    //刷新
    refreshList() {
      this.$refs["search"].resetFields();
      //this.search.xzqh = [];
      this.search.areaMin = null;
      this.search.areaMax = null;
      this.search.isPanorama = 0;
      this.search.parkCode = "";
      this.countyName = "";
      this.parkName = "";
      // this.search.type = "";
      // this.search.county = "";
      this.search.label = "";
      this.search.industryType = "";
      this.search.parkLevel = "";
      this.search.name = "";
      this.search.supplyPeriod = "";
      this.supplyPeriod1 = false;
      this.supplyPeriod2 = false;
      this.supplyPeriod3 = false;
      // this.search.sort = "";
      //this.search.sortFlag = true;
      this.xzqh = {
        //行政区划对象
        zs: null, //洲市
        qx: null, //区县
      };
      this.tdyt = {
        lv1: null, // 第一级
        lv2: null, //第二级
      };
      this.getList();
    },
    //切换页码
    handleCurrentChange(val) {
      this.search.current = val;
      this.getList();
    },

    //切换页条数
    handleSizeChange(val) {
      this.search.size = val;
      this.getList();
    },
    //添加需求
    releaseNeed() {
      this.$router.push({
        path: "/land/releaseNeed",
      });
    },

    async getList() {
      this.loading = true;
      let { data: res } = await landList(this.search);
      if (res.success) {
        let list = res.data.records;
        this.total = res.data.total;

        list.forEach((item) => {
          if (item.pronounceImages) {
            let imgUrl =
              item.pronounceImages.length > 0
                ? systemConfig.imgServer +
                  systemConfig.imgApi +
                  item.pronounceImages[0].filePath
                : null;
            this.$set(item, "imgUrl", imgUrl);
            item.pronounceImages = item.pronounceImages
              ? item.pronounceImages
              : [];
            if (item.pronounceImages.length) {
              item.pronounceImages.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "url",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.filePath
                );
              });
            }
            if (item.pronounceVideos && item.pronounceVideos.length) {
              item.pronounceVideos.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "thumbnailSrc",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.thumbnail
                );
              });
            }
          }
          this.$set(item, "checked", 0);
          this.contrastList.forEach((cItem) => {
            if (item.id == cItem) {
              item.checked = 1;
            }
          });
        });

        this.tableList = list;
        this.loading = false;
      } else {
        this.$message.error("查询失败");
        this.loading = false;
      }
    },
    changeChecked(e, data) {
      if (e) {
        this.contrastList.push({
          id: data.id,
          name: data.name,
          code: data.code,
        });
      } else {
        let index = this.contrastList.findIndex((item) => item.id == data.id);
        this.contrastList.splice(index, 1);
      }
    },
    progressFormat(p) {
      return "" + p;
    },
    areaSliderChange(val) {
      this.search.areaMax = val[1];
      this.search.areaMin = val[0];
    },
    handkeyCode(e) {
      if (e.keyCode === 13) {
        this.search.current = 1;
        this.getList();
      }
    },
  },
  destroyed() {
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "";
  },
  // 缓存组件进如时
  activated() {
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "1405px";
  },
  // 缓存组件离开时
  deactivated() {
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "";
  },
};
</script>
<style scoped>
.imgStyle {
  width: 12px;
}

.park-list {
  width: calc(245px * 5 + 10px * 11);
  margin: 0 auto;
  background: #fff;
  padding: 10px 35px;
  position: relative;
  /* min-height: calc(100% - 60px); */
  min-height: calc(100% - 346px);
  /* height: auto; */
  display: inline-table;
}

.search-box {
  display: block;
}

.search-btn {
  display: flex;
  justify-content: flex-end;
}

.badge-box {
  position: absolute;
  top: 100px;
  right: -66px;
}

.badge-img {
  width: 30px;
  height: 30px;
}

.table-box {
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  /*height: 100%;*/
}

.park-list-table {
  padding: 40px 0;
  border-bottom: 1px solid #c7c3c3;
  display: flex;
}

.park-list-table-checkbox {
  width: 30px;
  position: absolute;
  right: 7px;
}

::v-deep .el-checkbox__inner {
  width: 23px;
  height: 23px;
  border: 1px solid #626262;
}

.park-list-table-card {
  width: calc(100% - 50px);
}

::v-deep .el-checkbox__inner::after {
  height: 12px;
  width: 6px;
  top: 2px;
  left: 8px;
}

.park-list-table:hover {
  background: #f9f8f8;
}

.park-list-table:active {
  background-color: #00000010;
}

.page-box {
  margin: 10px 0;
  display: flex;
  justify-content: center;
}

::v-deep .page-box .el-pager li {
  border: 1px solid #409eff;
}

::v-deep .el-pagination button:disabled {
  color: #fff;
  background: #409eff;
}

::v-deep .el-pagination .btn-prev {
  margin: 0 10px;
  padding-right: 8px;
}

::v-deep .el-pagination .btn-next {
  padding-left: 8px;
  margin: 0 10px;
}

::v-deep .el-pager li {
  padding: 0;
  margin: 0 4px;
}

.font-red {
  color: red;
  cursor: pointer;
  padding-right: 30px;
}

.park-list-table-no {
  margin-top: 10px;
  width: 100%;
}

.park-list-table-no-top {
  /* text-align: right; */
  border-bottom: 1px solid #c7c3c3;
  font-size: 0.8rem;
  font-weight: 600;
  height: 48px;
  line-height: 48px;
  display: flex;
  justify-content: space-between;
  /* position: relative; */
}

.comparison-switch {
  /* display: inline-block;
  position: absolute;
  left: 20px; */
  /* margin-left: 20px; */
  display: flex;
  align-items: center;
}

.screen-box {
  display: flex;
  height: 32px;
  line-height: 32px;
}

.screen-box-div {
  width: 70px;
  border: 1px solid #dcdfe6;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
  margin-left: 15px;
  font-size: 0.85rem;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: normal;
}

/* .screen-box > div:hover {
  background: #fff;
  border-color: #409eff;
  color: #409eff;
} */
.screen-box-active {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}

.screen-box-icon {
  color: #085393;
}

.park-list-table-no-c {
  width: 300px;
  margin: 100px auto 50px;
}

.park-list-table-no-c-img {
  width: 100%;
}

.park-list-table-no-c-img > img {
  width: 100%;
}

.park-list-table-no-c-span {
  margin: 0 auto;
  width: 100%;
  text-align: center;
  font-size: 0.75rem;
  color: #c7c3c3;
}

.park-list-table-no-c-btn {
  font-size: 0.85rem;
  width: 120px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  margin: 20px auto;
  background: #1a6ec2;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
}

.contrast-list {
  position: fixed;
  top: 387px;
  right: 109px;
  z-index: 100;
}

/* >>> .table-box .el-card {
  width: 245px;
  display: inline-block;
  margin: 10px 10px;
  border-radius: 15px 10px 10px 10px;
} */

.card-info {
  font-size: 0.95rem;
  margin-left: 5px;
  max-width: 45%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.card-base {
  display: inline-block;
  position: relative;
  width: calc((100% - 80px) / 5);
  box-shadow: 0 0 4px #c7c3c3;
  margin-top: 15px;
  border-radius: 4px;
  overflow: hidden;
  margin-right: 15px;
  /*height: 267px;*/
}

.card-mask {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 162px;
  width: 254px;
  /* background: #b2b7b98c; */
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 600;
}

.yjy-color {
  background: rgba(187, 253, 196, 0.4);
  /* color: rgb(10, 207, 116); */
  color: rgb(0, 114, 62);
}

.wjy-color {
  /* color: rgb(255, 89, 132); */
  color: rgb(209, 0, 54);
  background: rgba(255, 179, 199, 0.4);
}

.card-base-box {
  cursor: pointer;
  width: 100%;
}

.card-base-box > img {
  width: 100%;
}

.card-title {
  margin: 2px 5px;
  font-size: 1.05rem;
  font-weight: bold;
  display: inline-block;
  width: calc(100% - 10px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pageView {
  width: 85px;
  /*position: absolute;*/
  /*right: 16px;*/
  text-align: right;
  /*top: 2px;*/
  cursor: pointer;
}

.color-4 {
  color: red;
}

.color-1 {
  color: #f4420a;
}

.color-2 {
  color: #ff6941;
}

.color-3 {
  color: #ff9001;
}

>>> .pageView .el-progress__text {
  color: #bfbfbf;
  margin: -13px 8px 8px -15px;
}

.need-area {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 27px;
}

.need-area-slider {
  display: inline-block;
  width: 100px;
  margin: 0 5px;
}

.need-area-input {
  width: 100px;
  display: inline-block;
  padding: 0 8px;
}

.left-top {
  max-width: 80px;
  line-height: 20px;
  height: 20px;
  position: absolute;
  left: 10px;
  top: 10px;
  background: #e56810;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 0.75rem;
  color: white;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.left-top span {
}

.right-top {
  width: 50px;
  height: 16px;
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 2px 6px;
  background: #00000059;
  border-radius: 5px;
  font-size: 0.75rem;
  color: #fff;
}

.right-bottom {
  position: absolute;
  right: 10px;
  top: 135px;
  padding: 2px 6px;
  background: #00000059;
  border-radius: 5px;
  font-size: 0.75rem;
  color: #fff;
}

.right-top span {
  display: block;
  color: white;
  width: 50px;
  height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-bottom {
  height: 30px;
  /*position: relative;*/
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}

.text-center {
  /*height: 20px;*/
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.text-bottom .price {
  /*position: absolute;*/
  /*left: 12px;*/
  /*top: 2px;*/
}

.text-bottom .price span {
  font-weight: bold;
}

.title-select {
  border: 1px solid #bfbfbf;
  padding: 20px 10px;
}

.tool-title {
  color: #979797;
  margin-top: 10px;
  display: inline-block;
}

.content {
  /*position: relative;*/
}

.input-box {
  position: absolute;
  top: 43px;
  left: 105px;
  background: #fff;
  /* border: 1px solid #e4e7ed; */
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  width: 200px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 99999;
}

.input-box > div {
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  font-size: 0.8rem;
  cursor: pointer;
}

.content span {
  color: #7c7c7c;
  display: inline-block;
  margin: 10px;
  cursor: pointer;
  font-weight: bold;
  font-size: 0.95rem;
}

.content span:hover {
  color: #58aec3;
}

.content .span-active {
  color: #1bbafd;
}

.content2 {
  margin-top: 10px;
}

.content2 span {
  font-weight: unset;
}

.bottom-line-dashed {
  border-bottom: 1px dashed #b5b5b5;
  position: relative;
}

.shrink {
  overflow: hidden;
  /* height: 88px; */
  height: 44px;
  /*position: relative;*/
}

.shrink-child {
  height: 0;
}

.more {
  position: absolute;
  right: 0px;
  top: 10px;
  font-size: 0.95rem;
  color: #00d2fd;
  cursor: pointer;
}

.shrink-btn {
  position: absolute;
  right: 0px;
  bottom: 10px;
  font-size: 0.95rem;
  color: #00d2fd;
  cursor: pointer;
}

.search-button {
  height: 28px;
  margin-left: 20px;
  line-height: 28px;
  padding: 0 20px;
  border-radius: 4px;
  font-weight: normal;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: 1px solid #dcdfe6;
}

.search-button:hover {
  /*opacity: 0.5;*/
}

.search-button-bgc1 {
  background: #18a7e9;
}

.search-button-bgc2 {
  background: #f5a702;
}

.search-button-bgc3 {
  background: #00baaf;
}

.select-bgc {
  /*opacity: 0.5;*/
  background: #409eff;
  color: #fff;
  border: none;
  /*font-weight: bold;*/
}

.develop {
  font-size: 0.85rem;
  cursor: pointer;
  margin-left: 10px;
}

.availableNear {
  background: rgb(73, 122, 255);
}

.available {
  background: rgb(2, 214, 74);
}

.availability {
  background: rgb(255, 174, 17);
}

.park-detail-top-title3-li1 {
  border-radius: 4px;
  /*background: #ff4c4c;*/
  color: #fff;
  text-align: center;
}

.park-detail-top-title3-span1 {
  text-align: center;
  align-items: center;
  font-size: 0.85rem;
  width: 70px;
  /*padding: 0 10px;*/
  height: 25px;
  /*font-weight: 600;*/
  /*padding: 5px;*/
  line-height: 28px;
  display: flex;
  justify-content: center;
  /*margin: 10px 5px;*/
  margin-left: 5px;
  margin-top: 5px;
}

.el-tag--mini {
  height: 25px;
  line-height: 25px;
  margin-top: 5px;
}

.intention {
  background-color: transparent;
}

.dk-announcement {
  width: 100%;
  height: 25px;
  color: #fff;
  background: #f98e48;
  line-height: 25px;
  font-size: 0.85rem;
  width: max-content;
  margin: 5px 0 0 5px;
  border-radius: 4px;
  padding: 0 5px;
}
.dk-announcement1 {
  width: 100%;
  height: 25px;
  color: #fff;
  background: #2090ff;
  line-height: 25px;
  font-size: 0.85rem;
  width: max-content;
  margin: 5px 0 0 5px;
  border-radius: 4px;
  padding: 0 5px;
}
.dk-announcement img {
  width: 16px;
  height: 16px;
}

.transfer-announce-status {
  margin-left: 15px;
  font-size: 0.85rem;
  color: #303133;
  font-weight: normal;
}

</style>
